module.exports = __webpack_public_path__ + "img/Man-8.f1c15e13.svg";